module.exports = __webpack_public_path__ + "img/STERiGLIDE_04_01.7b4e692f.jpg";